import { render, staticRenderFns } from "./CenterSidebarForm.vue?vue&type=template&id=437c21e8&scoped=true&"
import script from "./CenterSidebarForm.vue?vue&type=script&lang=js&"
export * from "./CenterSidebarForm.vue?vue&type=script&lang=js&"
import style0 from "./CenterSidebarForm.vue?vue&type=style&index=0&id=437c21e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437c21e8",
  null
  
)

export default component.exports